import { assert } from '../../lib/assert-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageCrew_crew } from './voyageCrew_crew-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageSystems } from './voyageSystems-sidecar'
import { voyageUiSubsystem } from './voyageUiSubsystem-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let useSystemTime = 2
  d.useSystemTimer += ds
  voyageCrew_crew.setProgress(obj, d.useSystemTimer / useSystemTime)

  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    if (voyageSystems.testNoPower(obj)) {
      return
    }

    let possibleReports: string[] = []

    let status = voyageGameStatus.get()
    let es = status.enemyShip
    if (es.active) {
      possibleReports.push(
        ...[
          'Enemy ship on radar!',
          'Ship class ' + es.class + ' sighted',
          '',
          'Enemy hull integrity at ' + es.hitpoints,
        ],
      )
    }

    if (possibleReports.length === 0) {
      possibleReports.push(
        ...['Nothing on radar', 'Nothing to report', '', 'Clear space ahead'],
      )
    } else {
      voyageSounds.playCompWarning2()
    }

    let report = rando.sample(possibleReports)
    voyageCrew.say(obj, report)
  }
}

export function onLeave(obj: IVoyageCrew) {
  voyageUiSubsystem.setOpen(false)
}

export function onSelectedCrewOn(obj: IVoyageCrew) {
  voyageUiSubsystem.setOpen(true, obj.tile)
}
